package article.spring

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.drawscope.Stroke

sealed class SpringCoilOrientation {
    data object Horizontal : SpringCoilOrientation()
    data object Vertical : SpringCoilOrientation()
}

@Composable
fun SpringCoil(
    segments: Int,
    orientation: SpringCoilOrientation,
    color: Color = springYellow,
) {
    Canvas(
        Modifier.fillMaxSize()
    ) {


        val path = Path()

        when (orientation) {
            is SpringCoilOrientation.Horizontal -> {
                val segmentLength = size.width / segments
                path.moveTo(0f, (size.height / 2) + (20f / 2))

                for (i in 0 until segments) {
                    path.relativeLineTo(segmentLength / 2, -20f)
                    path.relativeLineTo(segmentLength / 2, 20f)
                }
            }

            is SpringCoilOrientation.Vertical -> {
                val segmentLength = size.height / segments
                path.moveTo((size.width / 2) + (20f / 2), 0f)

                for (i in 0 until segments) {
                    path.relativeLineTo(-20f, segmentLength / 2)
                    path.relativeLineTo(20f, segmentLength / 2)
                }
            }
        }

        drawPath(
            path,
            color = color,
            style = Stroke(
                width = 12f,
                join = StrokeJoin.Bevel,
                cap = StrokeCap.Round,
            )
        )

    }
}